<template>
  <div>
    <vx-card  v-can="'view-staff'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-100 text-bold">Name</label>

        <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="mb-4 md:mb-0 w-full"/>
      </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Email</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['email']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Contact Number</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['contact_1']" class="mb-4 md:mb-0 w-full"/>
        </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                      color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
  <div class="vx-row">
    <!-- CARD 9: DISPATCHED ORDERS -->
    <div class="vx-col w-full">
      <vx-card title="STAFF" v-can:any="['create-staff', 'view-staff']">
        <template slot="actions">
            <vs-button v-can="'create-staff'" @click="onClickCreateStaff" class="mr-4" color="primary" type="filled">Create User</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                    v-model="filters['search']"
                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
          <vs-table v-can="'view-staff'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th sort-key="name">NAME</vs-th>
              <vs-th sort-key="email">EMAIL</vs-th>
              <vs-th sort-key="contact_1">CONTACT</vs-th>
              <vs-th>LAST LOGGED IN</vs-th>
              <vs-th class="float-left">USER</vs-th>
              <vs-th v-can="'edit-staff'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>
                <vs-td :data="data[indextr].contact_1">
                  {{ data[indextr].contact_1 }}
                </vs-td>

                <vs-td :data="data[indextr].last_login_at">
                  {{ data[indextr].last_login_at }}
                </vs-td>

                <vs-td :data="data[indextr].role">
                  {{ !!data[indextr].role ? data[indextr].role.name : ''}}
                </vs-td>

                <vs-td v-can="'edit-staff'">
                  <div class="vx-row">
                    <vx-tooltip text="Edit" position="left">
                      <!--                    <vs-button @click="popupActive=true"-->
                      <vs-button @click="onClickUserEdit(data[indextr].id)"
                                 radius color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                    </vx-tooltip>
<!--                    <vx-tooltip class="ml-3" text="Delete" position="left">-->
<!--                      &lt;!&ndash;                    <vs-button @click="popupActive=true"&ndash;&gt;-->
<!--                      <vs-button @click="openConfirm()"-->
<!--                                 radius color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>-->
<!--                    </vx-tooltip>-->
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

        </div>
      </vx-card>
    </div>
  </div>
    <update-staff-pop-up ref="trackingImages"/>
    <create-staff-pop-up ref="createStaffPopup"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import UpdateStaffPopUp from '@/components/popups/staff/UpdateStaffPopUp'
import CreateStaffPopUp from '@/components/popups/staff/CreateStaffPopUp'
const StaffRepository = RepositoryFactory.get('staff')
const DepartmentsRepository = RepositoryFactory.get('departments')

export default {
  name: 'AllUsersList',
  data () {
    return {
      selected: [],
      updateStaffSelected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createUserPopupActive: false,
      popUpTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      staff: [],
      selectedStaff: {},
      createStaffForm: {},
      departments: [],
      users: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  components: {
    'v-select': vSelect,
    UpdateStaffPopUp,
    CreateStaffPopUp
  },
  mixins : [Filter],
  async mounted () {

    this.$refs.filterCard.isContentCollapsed = true
    this.$refs.filterCard.maxHeight = '1.5rem'

    this.$vs.loading()
    this.loadDepartments()
    this.loadStaff()
    this.$vs.loading.close()

  },
  methods: {
    async refreshData () {
      this.loadStaff()
    },

    async onClickUserEdit (id) {
      await this.$refs.trackingImages.openPopup(id)
    },
    async loadDepartments() {
      this.$vs.loading()
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
      this.$vs.loading.close()
    },

    async loadStaff() {
      this.$vs.loading()
      const {data} = await StaffRepository.get(this.page, this.filterQuery, 10, this.sort)
      this.staff =  data.data
      this.meta = data.meta
      this.$vs.loading.close()
    },

    async onClickCreateStaff () {
      await this.$refs.createStaffPopup.openPopup()
    },

    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert () {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position:'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },

    filterQueryUpdate (){
      this.loadStaff()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadStaff()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadStaff()
      }

    }

  },
  watch : {
    page(){
      this.loadStaff()
    }
  }
}
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
